var _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeStoresHorizontalBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0H3.19841C2.86718 0 2.53594 0.210938 2.35526 0.527344L0.428071 4.18359C-0.595751 6.08203 0.307621 8.68359 2.17459 8.96484C2.32515 9 2.4456 9 2.59616 9C3.49954 9 4.28246 8.54297 4.82448 7.83984C5.3665 8.54297 6.14943 9 7.0528 9C7.7992 9 8.47961 8.66611 9 8.13004V0Z",
    fill: "#7583F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5H4.50321V10.0195C4.20209 10.0898 2.89729 10.125 2.59616 10.125C2.41549 10.125 2.23481 10.125 2.05414 10.0898C1.87347 10.0547 1.7229 10.0195 1.57234 9.98438V16.875C1.57234 17.5078 1.99392 18 2.53594 18H9V13.5Z",
    fill: "#7583F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H8.19841C7.86718 0 7.53594 0.210938 7.35526 0.527344L5.42807 4.18359C4.40425 6.08203 5.30762 8.68359 7.17459 8.96484C7.32515 9 7.4456 9 7.59616 9C8.49954 9 9.28246 8.54297 9.82448 7.83984C10.3665 8.54297 11.1494 9 12.0528 9C12.7992 9 13.4796 8.66611 14 8.13004V0Z",
    fill: "#7583F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5H9.50321V10.0195C9.20209 10.0898 7.89729 10.125 7.59616 10.125C7.41549 10.125 7.23481 10.125 7.05414 10.0898C6.87347 10.0547 6.7229 10.0195 6.57234 9.98438V16.875C6.57234 17.5078 6.99392 18 7.53594 18H14V13.5Z",
    fill: "#7583F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H13.1984C12.8672 0 12.5359 0.210938 12.3553 0.527344L10.4281 4.18359C9.40425 6.08203 10.3076 8.68359 12.1746 8.96484C12.3252 9 12.4456 9 12.5962 9C13.4995 9 14.2825 8.54297 14.8245 7.83984C15.3665 8.54297 16.1494 9 17.0528 9C17.7992 9 18.4796 8.66611 19 8.13004V0Z",
    fill: "#5062F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.5H14.5032V10.0195C14.2021 10.0898 12.8973 10.125 12.5962 10.125C12.4155 10.125 12.2348 10.125 12.0541 10.0898C11.8735 10.0547 11.7229 10.0195 11.5723 9.98438V16.875C11.5723 17.5078 11.9939 18 12.5359 18H19V13.5Z",
    fill: "#5062F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H24.8016C25.1328 0 25.4641 0.210938 25.6447 0.527344L27.5719 4.18359C28.5958 6.08203 27.6924 8.68359 25.8254 8.96484C25.6748 9 25.5544 9 25.4038 9C24.5005 9 23.7175 8.54297 23.1755 7.83984C22.6335 8.54297 21.8506 9 20.9472 9C20.2008 9 19.5204 8.66611 19 8.13004V0Z",
    fill: "#5062F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.5H23.4968V10.0195C23.7979 10.0898 25.1027 10.125 25.4038 10.125C25.5845 10.125 25.7652 10.125 25.9459 10.0898C26.1265 10.0547 26.2771 10.0195 26.4277 9.98438V16.875C26.4277 17.5078 26.0061 18 25.4641 18H19V13.5Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeStoresHorizontalBlue);
export default __webpack_public_path__ + "static/media/threeStoresHorizontalBlue.6ffa2c08f4d1e8e4160f0172b30994d6.svg";
export { ForwardRef as ReactComponent };